import { render, staticRenderFns } from "./SportBets.vue?vue&type=template&id=73520e14&scoped=true&"
import script from "./SportBets.vue?vue&type=script&lang=js&"
export * from "./SportBets.vue?vue&type=script&lang=js&"
import style0 from "./SportBets.vue?vue&type=style&index=0&id=73520e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73520e14",
  null
  
)

component.options.__file = "SportBets.vue"
export default component.exports